import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store.js'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/produto/:idGarrafa/:tituloGarrafa',
      name: 'produto',
      component: () => import('./views/Produto.vue'),
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/s/:strPesquisa',
      name: 'pesquisa',
      component: () => import('./views/Pesquisar.vue'),
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/bebida/:idBebida/:tituloBebida',
      name: 'bebida',
      component: () => import('./views/Bebida.vue'),
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})
export default router